import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { classNames } from '~/utils';

export interface DropdownMenuProps extends RadixDropdownMenu.DropdownMenuProps {
  align?: RadixDropdownMenu.DropdownMenuContentProps['align'];
  sideOffset?: RadixDropdownMenu.DropdownMenuContentProps['sideOffset'];
  disabled?: RadixDropdownMenu.DropdownMenuTriggerProps['disabled'];
  trigger: React.ReactNode;
  contentClassname?: string;
  onEscapeKeyDown?: RadixDropdownMenu.DropdownMenuContentProps['onEscapeKeyDown'];
}

export function DropdownMenu({
  align = 'start',
  disabled = false,
  sideOffset = 2,
  children,
  trigger,
  contentClassname,
  onEscapeKeyDown,
  ...props
}: DropdownMenuProps) {
  return (
    <RadixDropdownMenu.Root {...props}>
      <RadixDropdownMenu.Trigger asChild disabled={disabled}>
        {trigger}
      </RadixDropdownMenu.Trigger>

      <RadixDropdownMenu.Portal>
        <RadixDropdownMenu.Content
          align={align}
          alignOffset={-1}
          className={classNames('z-10 rounded-sm border border-neutral-200 bg-white py-2 shadow-md', contentClassname)}
          onEscapeKeyDown={onEscapeKeyDown}
          sideOffset={sideOffset}
        >
          {children}
        </RadixDropdownMenu.Content>
      </RadixDropdownMenu.Portal>
    </RadixDropdownMenu.Root>
  );
}
